import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/company_page_configurator/pages/RootPage'))

const RedirectToContentOnIndexPage = React.lazy(
  () => import('modules/company_page_configurator/pages/RedirectToContentOnIndexPage')
)

const HeaderPage = React.lazy(() => import('modules/company_page_configurator/pages/HeaderPage'))
const HomePage = React.lazy(() => import('modules/company_page_configurator/pages/HomePage'))
const JobsPage = React.lazy(() => import('modules/company_page_configurator/pages/JobsPage'))
const LayoutPage = React.lazy(() => import('modules/company_page_configurator/pages/LayoutPage'))
const LegalNoticePage = React.lazy(
  () => import('modules/company_page_configurator/pages/LegalNoticePage')
)
const PerksPage = React.lazy(() => import('modules/company_page_configurator/pages/PerksPage'))
const TeamPage = React.lazy(() => import('modules/company_page_configurator/pages/TeamPage'))
const TermsPage = React.lazy(() => import('modules/company_page_configurator/pages/TermsPage'))
const ValuesPage = React.lazy(() => import('modules/company_page_configurator/pages/ValuesPage'))
const NewValuePage = React.lazy(
  () => import('modules/company_page_configurator/pages/NewValuePage')
)
const EditValuePage = React.lazy(
  () => import('modules/company_page_configurator/pages/EditValuePage')
)
const AppearancePage = React.lazy(
  () => import('modules/company_page_configurator/pages/AppearancePage')
)
const OfficesPage = React.lazy(() => import('modules/company_page_configurator/pages/OfficesPage'))
const UpsertOfficePage = React.lazy(
  () => import('modules/company_page_configurator/pages/UpsertOfficePage')
)

export const companyPageConfiguratorRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.careers.path,
    element: <RootPage />,
    children: [
      {
        index: true,
        element: <RedirectToContentOnIndexPage />,
      },
      {
        path: navigation.careers.content.path,
        element: <LayoutPage />,
        children: [
          {
            index: true,
            element: <HomePage />,
          },
          {
            path: navigation.careers.content.header.path,
            element: <HeaderPage />,
          },
          {
            path: navigation.careers.content.terms.path,
            element: <TermsPage />,
          },
          {
            path: navigation.careers.content.team.path,
            element: <TeamPage />,
          },
          {
            path: navigation.careers.content.jobs.path,
            element: <JobsPage />,
          },
          {
            path: navigation.careers.content.benefits.path,
            element: <PerksPage />,
          },
          {
            path: navigation.careers.content.values.path,
            element: <ValuesPage />,
            children: [
              {
                path: navigation.careers.content.values.new.path,
                element: <NewValuePage />,
              },
              {
                path: navigation.careers.content.values.edit.path,
                element: <EditValuePage />,
              },
            ],
          },
          {
            path: navigation.careers.content.offices.path,
            element: <OfficesPage />,
            children: [
              {
                path: navigation.careers.content.offices.upsert.path,
                element: <UpsertOfficePage />,
              },
            ],
          },
          {
            path: navigation.careers.content.legal_notice.path,
            element: <LegalNoticePage />,
          },
        ],
      },
      {
        path: navigation.careers.appearance.path,
        element: <AppearancePage />,
      },
    ],
  },
]
